<template>
  <div id="app">
    <router-view/>
    <notifications group="mgs"
                   position="top right"
                   animation-type="velocity"
                   :speed="1000"/>
    <portal-target name="modal"></portal-target>
  </div>
</template>

<script>
export default {}
</script>